module.exports = __webpack_public_path__ + "media/images/icons/icon-board-2116e7d3e3fc28e417208d2c06fc4a90.svg";